import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useLocation} from 'react-router-dom';

import {getBookingNotifications} from '../../../redux/actions/Booking/Notification/bookingNotificationActions';
import {BOOKING_NOTIFICATION_POLL_MS} from '../../../constants/Booking/bookingNotification.constants';
import {isBookingNotificationEnabled} from './bookingNotificationHelpers';
import {isLogged} from '../../../utils';

/**
 * Yoklama motoru. Ozel rotalarin kokune (PrivateUrls) BIR KEZ mount edilir —
 * boylece sayfa gecislerinde interval sifirlanmaz ve cursor kaybolmaz.
 *
 * Sekme arkaya alindiginda yoklama durdurulmaz (belgedeki istemci kurali).
 * Sunucu maliyeti olculdu: yoklama basina iki hafif sorgu, 30 sn guvenli.
 */
export default function BookingNotificationPoller() {

    const dispatch = useDispatch();
    const location = useLocation();

    // Bagimlilik bir BOOLEAN: her gezinmede degil, yalnizca durum degistiginde
    // (orn. tesis secilip /app'ten cikildiginda) effect yeniden kurulur.
    const enabled = isLogged() && isBookingNotificationEnabled(location.pathname);

    useEffect(() => {

        if (!enabled) {
            return undefined;
        }

        dispatch(getBookingNotifications());

        const timer = setInterval(() => {
            dispatch(getBookingNotifications());
        }, BOOKING_NOTIFICATION_POLL_MS);

        return () => clearInterval(timer);
    }, [enabled, dispatch]);

    return null;
}
